import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { Color3 } from '@babylonjs/core/Maths/math';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { MeshBuilder } from '@babylonjs/core/Meshes/meshBuilder';
import { Scene } from '@babylonjs/core/scene';
import { Feature } from '@kb3d/models/classes';

export function createMirrorVisualization(mirror: Feature, scene: Scene, color?: Color3) {
    if (!color) {
        color = Color3.Yellow();
    }

    const mirrorVisualization: Mesh = MeshBuilder.CreatePlane('mirrorPlane', {}, scene);
    const coloredMaterial = new StandardMaterial('', scene);
    coloredMaterial.wireframe = true;
    coloredMaterial.emissiveColor = color;
    mirrorVisualization.material = coloredMaterial;

    mirrorVisualization.isPickable = false;
    mirrorVisualization.setEnabled(true);
    return mirrorVisualization;
}
